import React from 'react'
import Panel from '../../components/Panel'
import styles from './Introduction.css'

export default function Introduction () {
  return (
    <Panel className={styles.root}>
      We are Intuxicated, an 11-piece band of graduates from Loughborough University. Our mission is to deliver good quality, affordable, live music for any occasion.
    </Panel>
  )
}



// WEBPACK FOOTER //
// ./app/views/Introduction/Introduction.js